import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterByPaidBills'
})

export class FilterByPaidBills implements PipeTransform {
    transform(items: any[], paid: string): any {
       
        if(!items || paid == null){
            return items;
        }

        return items.filter((item,index) => {
            //console.log(index);
            if(item.payed == paid) return true;
            //(item.payed == paid) ? return true : return false;
        })
        
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/filter-unpaid.pipe.ts